export default __webpack_public_path__ + "static/tertiary-b6438d68a358d7269b327ebe37f58e3f.jpg";